// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upskld_people_pg_wrapper {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  padding: 64px 24px 80px;
  background: #f7f3e9;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "Manrope", sans-serif;
}

.upskld_people_pg_header_block {
  max-width: 720px;
  text-align: center;
  margin-bottom: 48px;
}

.upskld_people_pg_eyebrow {
  display: inline-block;
  font-size: 12.5px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: #b8862f;
  margin-bottom: 14px;
}





.upskld_people_pg_avatar {
  width: 164px;
  height: 184px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  background: #f0e9d8;
  border: 1px solid #e8e2d2;
}

.upskld_people_pg_avatar_img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.upskld_people_pg_title {
  margin: 0 0 20px;
  font-size: 36px;
  font-weight: 500;
  line-height: 1.3;
  color: #1c1c1c;
  font-family: Georgia, "Times New Roman", serif;
}

.upskld_people_pg_title_italic {
  font-style: italic;
  color: #b8862f;
}

.upskld_people_pg_subtitle {
  margin: 0;
  font-size: 15.5px;
  line-height: 1.7;
  color: #6b6b6b;
  font-weight: 400;
}

.upskld_people_pg_grid {
  width: 100%;
  max-width: 1200px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.upskld_people_pg_card {
  background: #ffffff;
  border: 1px solid #e8e2d2;
  border-radius: 14px;
  padding: 32px 22px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.upskld_people_pg_card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.08);
}


.upskld_people_pg_avatar_text {
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
}

.upskld_people_pg_name {
  margin: 0 0 6px;
  font-size: 17px;
  font-weight: 600;
  color: #1c1c1c;
}

.upskld_people_pg_role {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.6px;
  color: #b8862f;
  text-transform: uppercase;
  margin-bottom: 12px;
}

.upskld_people_pg_tags {
  margin: 0;
  font-size: 13.5px;
  line-height: 1.6;
  color: #6b6b6b;
  font-weight: 400;
}

/* Tablet */
@media (max-width: 1024px) {
  .upskld_people_pg_grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .upskld_people_pg_title {
    font-size: 30px;
  }
}

/* Mobile responsive - down to 480px */
@media (max-width: 480px) {
  .upskld_people_pg_wrapper {
    padding: 48px 16px 60px;
  }

  .upskld_people_pg_grid {
    grid-template-columns: 1fr;
    gap: 18px;
  }

  .upskld_people_pg_title {
    font-size: 24px;
  }

  .upskld_people_pg_subtitle {
    font-size: 14px;
  }

  .upskld_people_pg_card {
    padding: 26px 18px;
  }
}

/* Mobile responsive - down to 360px */
@media (max-width: 360px) {
  .upskld_people_pg_wrapper {
    padding: 40px 12px 48px;
  }

  .upskld_people_pg_title {
    font-size: 20px;
  }

  .upskld_people_pg_avatar {
    width: 56px;
    height: 56px;
  }
}`, "",{"version":3,"sources":["webpack://./src/STUDENTPLATFORM/StudentFooter/StudentFooter.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;;;;;AAMA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;;AAGA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,sCAAsC;AACtC;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":[".upskld_people_pg_wrapper {\n  width: 100%;\n  min-height: 100vh;\n  box-sizing: border-box;\n  padding: 64px 24px 80px;\n  background: #f7f3e9;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  font-family: \"Manrope\", sans-serif;\n}\n\n.upskld_people_pg_header_block {\n  max-width: 720px;\n  text-align: center;\n  margin-bottom: 48px;\n}\n\n.upskld_people_pg_eyebrow {\n  display: inline-block;\n  font-size: 12.5px;\n  font-weight: 700;\n  letter-spacing: 1.4px;\n  text-transform: uppercase;\n  color: #b8862f;\n  margin-bottom: 14px;\n}\n\n\n\n\n\n.upskld_people_pg_avatar {\n  width: 164px;\n  height: 184px;\n  border-radius: 50%;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 16px;\n  background: #f0e9d8;\n  border: 1px solid #e8e2d2;\n}\n\n.upskld_people_pg_avatar_img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.upskld_people_pg_title {\n  margin: 0 0 20px;\n  font-size: 36px;\n  font-weight: 500;\n  line-height: 1.3;\n  color: #1c1c1c;\n  font-family: Georgia, \"Times New Roman\", serif;\n}\n\n.upskld_people_pg_title_italic {\n  font-style: italic;\n  color: #b8862f;\n}\n\n.upskld_people_pg_subtitle {\n  margin: 0;\n  font-size: 15.5px;\n  line-height: 1.7;\n  color: #6b6b6b;\n  font-weight: 400;\n}\n\n.upskld_people_pg_grid {\n  width: 100%;\n  max-width: 1200px;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 24px;\n}\n\n.upskld_people_pg_card {\n  background: #ffffff;\n  border: 1px solid #e8e2d2;\n  border-radius: 14px;\n  padding: 32px 22px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n}\n\n.upskld_people_pg_card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.08);\n}\n\n\n.upskld_people_pg_avatar_text {\n  color: #ffffff;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.upskld_people_pg_name {\n  margin: 0 0 6px;\n  font-size: 17px;\n  font-weight: 600;\n  color: #1c1c1c;\n}\n\n.upskld_people_pg_role {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.6px;\n  color: #b8862f;\n  text-transform: uppercase;\n  margin-bottom: 12px;\n}\n\n.upskld_people_pg_tags {\n  margin: 0;\n  font-size: 13.5px;\n  line-height: 1.6;\n  color: #6b6b6b;\n  font-weight: 400;\n}\n\n/* Tablet */\n@media (max-width: 1024px) {\n  .upskld_people_pg_grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .upskld_people_pg_title {\n    font-size: 30px;\n  }\n}\n\n/* Mobile responsive - down to 480px */\n@media (max-width: 480px) {\n  .upskld_people_pg_wrapper {\n    padding: 48px 16px 60px;\n  }\n\n  .upskld_people_pg_grid {\n    grid-template-columns: 1fr;\n    gap: 18px;\n  }\n\n  .upskld_people_pg_title {\n    font-size: 24px;\n  }\n\n  .upskld_people_pg_subtitle {\n    font-size: 14px;\n  }\n\n  .upskld_people_pg_card {\n    padding: 26px 18px;\n  }\n}\n\n/* Mobile responsive - down to 360px */\n@media (max-width: 360px) {\n  .upskld_people_pg_wrapper {\n    padding: 40px 12px 48px;\n  }\n\n  .upskld_people_pg_title {\n    font-size: 20px;\n  }\n\n  .upskld_people_pg_avatar {\n    width: 56px;\n    height: 56px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
